// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"63c8b7c9","703":"0be49714","787":"cfdbd58b"}[chunkId] + ".chunk.js";
};